'use strict'

/** Jsep 互換の条件式 AST ヘルパー（GenericMapping single/multi condition 共通） CallExpression の引数は必ず Literal ノードにする（文字列直置き不可） */

/**
 * Col(fileType, columnName) を表す CallExpression
 *
 * @param {string} fileType
 * @param {string} columnName
 * @returns {{
 *   type: 'CallExpression'
 *   callee: { type: 'Identifier'; name: 'col' }
 *   arguments: { type: 'Literal'; value: string }[]
 * }}
 */
export function astCol(fileType, columnName) {
  return {
    type: 'CallExpression',
    callee: { type: 'Identifier', name: 'col' },
    arguments: [
      { type: 'Literal', value: String(fileType ?? '') },
      { type: 'Literal', value: String(columnName ?? '') }
    ]
  }
}

/**
 * Literal ノード
 *
 * @param {string | number | boolean} value
 * @returns {{ type: 'Literal'; value: string | number | boolean }}
 */
export function astLiteral(value) {
  return { type: 'Literal', value }
}
